import { render, staticRenderFns } from "./afiliacion.vue?vue&type=template&id=753fdcb0&"
import script from "./afiliacion.vue?vue&type=script&lang=js&"
export * from "./afiliacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports